'use strict';exports.__esModule = true;var _extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reduxForm = require('redux-form');
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _reactScroll = require('react-scroll');

var _components = require('../../components');





var _UploadWidget = require('./UploadWidget');var _UploadWidget2 = _interopRequireDefault(_UploadWidget);

var _constants = require('./constants');var _constants2 = _interopRequireDefault(_constants);

var _AddPropertiesToProject = require('./AddPropertiesToProject.scss');var styles = _interopRequireWildcard(_AddPropertiesToProject);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}var

AddPropertyBlock = function (_Component) {_inherits(AddPropertyBlock, _Component);function AddPropertyBlock() {var _temp, _this, _ret;_classCallCheck(this, AddPropertyBlock);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.




    deleteProperty = function (fields, index) {
      var project_id = (0, _get2.default)(_this.props, 'initialValues.propertyBlock[' + index + '].project_id', null);
      var property_id = (0, _get2.default)(_this.props, 'initialValues.propertyBlock[' + index + '].id', null);

      var handleDeleteProperty = function handleDeleteProperty() {
        fields.remove(index);
        _this.props.initialValues.propertyBlock.splice(index, 1);
        _this.props.deleteMyPropertyByProject({ project_id: project_id, property_id: property_id, token: _this.props.userToken });
        _this.props.hideMessageModal();
      };

      if (project_id && property_id) {
        _this.props.openMessageModal({
          message:
          _react2.default.createElement('div', { className: 'contentMessage' },
            _react2.default.createElement('div', null,
              _react2.default.createElement('p', null, _this.props.translate('myProjects', 'deletePropertyModal')),
              _react2.default.createElement('div', { className: styles.modalButtonWrapper },
                _react2.default.createElement('button', {
                    className: 'btn btn-primary',
                    onClick: handleDeleteProperty },

                  _this.props.translate('myProjects', 'yes')),

                _react2.default.createElement('button', {
                    className: 'btn btn-primary',
                    onClick: _this.props.hideMessageModal },

                  _this.props.translate('myProjects', 'no'))))) });






      } else {
        fields.remove(index);
      }
    }, _this.

    renderSize = function (_ref) {var input = _ref.input,meta = _ref.meta;return _this.renderInput(Object.assign({}, input), meta, 'area', 'number');}, _this.

    renderInput = function (input, meta, placeholder) {var type = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'text';return (
        _react2.default.createElement('input', _extends({},
        input, {
          type: type,
          placeholder: _this.props.translate('addNewProject', placeholder),
          className: (0, _classnames2.default)(styles.inputNumb, styles.numeric, 'form-control',
          { not_valid: meta.touched && meta.error && !meta.active }) })));}, _this.



    renderMultiRadio = function (name) {return (
        _this.props.creationNewHomes.propertyTypes.map(function (item, index) {return (
            _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.radioWrapper, 'radio'), key: item.name + '.' + name },
              _react2.default.createElement('label', { htmlFor: item.name + '.' + name },
                _react2.default.createElement(_reduxForm.Field, {
                  name: name,
                  component: 'input',
                  type: 'radio',
                  value: item.name,
                  id: item.name + '.' + name }),

                _react2.default.createElement('span', { className: styles.label },
                  _react2.default.createElement('span', null, _this.props.translate('propertyTypes', item.name))))));}));}, _this.






    renderForm = function (_ref2) {var fields = _ref2.fields,meta = _ref2.meta;var _this$props$fields$pr =
      _this.props.fields.propertiesToProject,propertiesToProject = _this$props$fields$pr === undefined ? [] : _this$props$fields$pr;var
      isForeign = _this.props.isForeign;

      var addForm = function addForm() {return fields.push({ rooms: Number(_constants2.default[0].value), key: Date.now() });};

      return (
        _react2.default.createElement('div', null,
          fields.map(function (property, index) {var _cx;
            var key = fields.get(index).key || fields.get(index).id;

            var removeForm = function removeForm() {return fields.remove(index);};
            var handleDeleteProperty = function handleDeleteProperty() {return _this.deleteProperty(fields, index);};

            return (
              _react2.default.createElement('div', { key: key, className: styles.formWrapper },
                _react2.default.createElement('div', { className: styles.formTitle },
                  _react2.default.createElement('h4', null, _this.props.translate('addNewProject', 'propertiesInProject'), ' ', index + 1),
                  _react2.default.createElement('div', { className: styles.buttonWrapper },
                    _react2.default.createElement('button', {
                        type: 'button',
                        onClick: !_this.props.isEditProject ? removeForm : handleDeleteProperty },

                      _this.props.translate('addNewProject', 'delete')))),



                _react2.default.createElement(_UploadWidget2.default, {
                  translate: _this.props.translate,
                  locale: _this.props.locale,
                  isMobile: _this.props.isMobile,
                  userToken: _this.props.userToken,
                  changeValue: _this.props.changeValue,
                  fields: _this.props.fields,
                  index: index,
                  addAssetToDelete: _this.props.addAssetToDelete,
                  initialValues: _this.props.initialValues,
                  property: property,
                  openMessageModal: _this.props.openMessageModal }),

                _react2.default.createElement(_reactScroll.Element, { name: property + '.start_price', className: styles.priceWrapper },
                  _react2.default.createElement('div', { className: styles.label },
                    _this.props.translate('addNewProject', 'price'),
                    _react2.default.createElement('span', { className: 'req' }, '*')),

                  _react2.default.createElement('div', { className: styles.fieldset },
                    _react2.default.createElement(_components.OMPriceInput, {
                      field: property + '.start_price',
                      locale: _this.props.locale,
                      isForeign: true,
                      placeholder: '' + _this.props.translate('addNewProject', 'minimalPrice'),
                      isMobile: _this.props.isMobile,
                      withLabel: false }),

                    _this.props.translate('addNewProject', 'or'),
                    _react2.default.createElement(_components.OMPriceInput, {
                      field: property + '.exact_price',
                      isForeign: true,
                      locale: _this.props.locale,
                      placeholder: '' + _this.props.translate('addNewProject', 'exactPrice'),
                      isMobile: _this.props.isMobile,
                      withLabel: false }))),



                _react2.default.createElement(_reactScroll.Element, { name: property + '.area', className: styles.size },
                  _react2.default.createElement('div', { className: styles.label },
                    _this.props.translate('addNewProject', 'area'),
                    _react2.default.createElement('span', { className: 'req' }, '*')),

                  _react2.default.createElement('div', { className: styles.area },
                    _react2.default.createElement(_reduxForm.Field, {
                      name: property + '.area',
                      type: 'text',
                      component: _this.renderSize }),

                    _react2.default.createElement('span', null, '\u33A1'))),


                _react2.default.createElement(_reactScroll.Element, { name: property + '.property_type', className: styles.property },
                  _react2.default.createElement('div', { className: styles.label },
                    _this.props.translate('addNewProject', 'property'),
                    _react2.default.createElement('span', { className: 'req' }, '*')),

                  _react2.default.createElement('div', { className: styles.propertyWrapper },
                    _this.renderMultiRadio(property + '.property_type'))),


                _react2.default.createElement(_reactScroll.Element, { name: property + '.rooms', className: styles.roomsWrapper },
                  _react2.default.createElement('div', { className: styles.label },
                    _this.props.translate('addNewProject', 'rooms'),
                    _react2.default.createElement('span', { className: 'req' }, '*')),

                  _react2.default.createElement(_components.OMSegmentedControl, {
                    inReduxForm: true,
                    className: (0, _classnames2.default)((_cx = {}, _cx[
                    styles.not_valid] = meta.touched && meta.error && !meta.active, _cx),
                    'multiButtons rounded'),

                    name: property + '.rooms',
                    values: _constants2.default,
                    selectedValue: (0, _get2.default)(propertiesToProject, index + '.rooms') })),


                _react2.default.createElement(_reactScroll.Element, { name: property + '.name', className: styles.hebrew },
                  _react2.default.createElement('div', { className: styles.label },
                    _this.props.translate('addNewProject', 'name'),
                    _react2.default.createElement('span', { className: 'req' }, '*')),

                  _react2.default.createElement(_components.OMTextFieldWithOptionsLang, {
                    translate: _this.props.translate,
                    classNameTabs: 'project-form',
                    className: 'form-control',
                    name: property + '.name',
                    locale: _this.props.locale,
                    isInput: true,
                    fields: (0, _get2.default)(propertiesToProject, index + '.name'),
                    maxLength: '80',
                    placeholderInput: _this.props.translate('addNewProject'),
                    isOptionalLangsDisabled: !(0, _get2.default)(propertiesToProject, index + '.name.' + (isForeign ? 'en' : 'he')),
                    isForeign: isForeign })),


                _react2.default.createElement(_reactScroll.Element, { name: property + '.summary', className: styles.description },
                  _react2.default.createElement('div', { className: styles.label },
                    _this.props.translate('addNewProject', 'descriptionPlan'),
                    _react2.default.createElement('span', { className: 'req' }, '*')),

                  _react2.default.createElement(_components.OMTextFieldWithOptionsLang, {
                    translate: _this.props.translate,
                    classNameTabs: 'project-form',
                    className: 'form-control',
                    fields: (0, _get2.default)(propertiesToProject, index + '.summary'),
                    maxLength: '250',
                    name: property + '.summary',
                    locale: _this.props.locale,
                    placeholderInput: _this.props.translate('addNewProject'),
                    isOptionalLangsDisabled:
                    !(0, _get2.default)(propertiesToProject, index + '.summary.' + (isForeign ? 'en' : 'he')),

                    isForeign: isForeign }))));




          }),
          _react2.default.createElement('button', {
              type: 'button',
              className: styles.addPropertyButton,
              onClick: addForm },

            _react2.default.createElement('span', { className: styles.plus }, '+'),
            _this.props.translate('addNewProject', 'addProperty'))));



    }, _temp), _possibleConstructorReturn(_this, _ret);}AddPropertyBlock.prototype.componentDidMount = function componentDidMount() {window.scrollTo(0, 0);};AddPropertyBlock.prototype.

  render = function render() {
    return _react2.default.createElement(_reduxForm.FieldArray, { name: this.props.name, component: this.renderForm });
  };return AddPropertyBlock;}(_react.Component);exports.default = AddPropertyBlock;


AddPropertyBlock.propTypes = {
  push: _propTypes2.default.func.isRequired,
  name: _propTypes2.default.string.isRequired,
  translate: _propTypes2.default.string.isRequired,
  fields: _propTypes2.default.object,
  locale: _propTypes2.default.string.isRequired,
  isMobile: _propTypes2.default.bool,
  userToken: _propTypes2.default.string,
  changeValue: _propTypes2.default.func,
  addAssetToDelete: _propTypes2.default.func,
  hideMessageModal: _propTypes2.default.func,
  openMessageModal: _propTypes2.default.func,
  isRtl: _propTypes2.default.bool,
  isEditProject: _propTypes2.default.bool,
  creationNewHomes: _propTypes2.default.object,
  deleteMyPropertyByProject: _propTypes2.default.object,
  initialValues: _propTypes2.default.object,
  isForeign: _propTypes2.default.bool };module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/AddPropertiesToProjectForm/AddPropertyBlock.js
// module id = 2887
// module chunks = 0